<template>
  <div class="flex flex-col gap-y-8 animate-pulse">
    <div class="h-9 bg-gray-200 rounded-lg w-1/2"></div>

    <div class="flex flex-col gap-y-3">
      <div class="h-6 bg-gray-200 rounded w-1/4"></div>
      <div class="flex gap-x-3 justify-between">
        <div
          v-for="i in 4"
          :key="i"
          class="h-12 bg-gray-200 rounded-lg flex-1"
        ></div>
      </div>
    </div>

    <div class="flex flex-col gap-y-6">
      <div class="h-6 bg-gray-200 rounded w-1/3"></div>
      <div class="h-14 bg-gray-200 rounded-lg"></div>
      <div class="h-14 bg-gray-200 rounded-lg"></div>
    </div>

    <div class="flex flex-col gap-y-6">
      <div class="h-6 bg-gray-200 rounded w-1/4"></div>
      <div class="h-14 bg-gray-200 rounded-lg"></div>
    </div>

    <div class="h-12 bg-gray-200 rounded-lg"></div>
  </div>
</template>

<script setup></script>
